// extracted by mini-css-extract-plugin
export default {"subtitle":"flYK8aM9tAefyqbjhLzZ","text":"TYJNQYVHkv6IjFMpvHE4"};